import { Box, Button } from "@mantine/core";
import { IconArrowLeft, IconArrowRight } from "@tabler/icons-react";
import { STYLE } from "@jasper/shared";
import { LIMIT_PAGINATION_QUANTITY } from "../../../constants/orders";

interface Props {
  page: number;
  setPage: (page: number) => void;
  totalOrderCount: number;
  currentPageOrderCount: number;
}

const Pagination = ({
  page,
  setPage,
  totalOrderCount,
  currentPageOrderCount,
}: Props) => {
  const isLastPage =
    (page - 1) * LIMIT_PAGINATION_QUANTITY + currentPageOrderCount >=
    totalOrderCount;

  return (
    <Box style={{ display: "flex", justifyContent: "space-between" }}>
      <Box>
        {page > 1 && (
          <div style={{ marginTop: "1rem", textAlign: "center" }}>
            <Button
              data-testid="previous-page-button"
              color={STYLE.primary}
              onClick={() => {
                setPage(page - 1);
              }}
            >
              <IconArrowLeft style={{ marginRight: "5px" }} /> Previous page
            </Button>
          </div>
        )}
      </Box>
      <Box style={{ marginTop: "1rem" }}>
        Page {page}, total: {totalOrderCount} orders
      </Box>
      <Box>
        {!isLastPage && (
          <div style={{ marginTop: "1rem", textAlign: "center" }}>
            <Button
              data-testid="next-page-button"
              color={STYLE.primary}
              onClick={() => {
                setPage(page + 1);
              }}
            >
              <IconArrowRight style={{ marginRight: "5px" }} /> Next page
            </Button>
          </div>
        )}
      </Box>
    </Box>
  );
};

export default Pagination;
